module.exports = __webpack_public_path__ + "static/media/desktop_background_gravestone.495f0e6e.png";